import { Component, OnInit, ViewChild } from '@angular/core';
import {
  AlertController,
  NavController,
  NavParams,
  LoadingController,
} from '@ionic/angular';
import { ReportService } from '../../services/report.service';
import { UserService } from '../../services/user.service';
import { Stylist } from '../../models/stylist/stylist.model';
import { Utilities } from '../../utilities/utilities';
import { SMPickerRange } from '../../components/smr-date-picker/smr-date-picker.component';
import { StylistPickerComponent } from '../../components/stylist-picker/stylist-picker.component';
import { ChartsService } from '../../services/charts.service';

// import { GoogleAnalytics } from '@awesome-cordova-plugins/google-analytics';
import { ExportTableService } from '../../services/export-table.service';
import { CalendarService } from '../../services/calendar.service';
import { Router } from '@angular/router';
import { ChartConfiguration,ChartType, ChartTypeRegistry } from 'chart.js';

interface IRow {
  name: string;
  type: number;
  amount: number;
  usage: number;
}
interface primeNgCol {
  field: string;
  header: string;
}
type MyChartTypeRegistry = {
  bar: ChartType;
  line: ChartType;
  radar: ChartType;
  // ... other chart types
};

@Component({
  selector: 'app-discount-report',
  templateUrl: './discount-report.page.html',
  styleUrls: ['./discount-report.page.scss'],
})
export class DiscountReportPage implements OnInit {
  // @ViewChild(Content) content: Content;

  @ViewChild(StylistPickerComponent)
  stylistPickerComponent: StylistPickerComponent;

  public stats: Array<IRow>;

  public cols: primeNgCol[];

  public stylistID: number;

  public stylist: Stylist;

  public yearIndicator: boolean = false;

  public xAxisDateChanger: string;

  public readOnlyStylistPicker: boolean;

  public isLoading: boolean;

  public errorOccurredWhileLoadingStylistPicker: boolean;

  public errorOccurredWhileLoadingStats: boolean;

  public startDate: Date;

  public endDate: Date;

  public barChartOptions: any;

  public barChartLabels: string[] = [];

  public barChartType: keyof MyChartTypeRegistry = 'bar';

  public barChartData: ChartConfiguration<'bar'>['data'] = {
    labels: this.barChartLabels,
    datasets: [
      {
        data: [],
        label: 'Times Used',
        backgroundColor: `rgba( 142, 205, 210, 0.8)`,
        borderColor: `rgba(142, 205, 210, 1)`,
      },
    ],
  };

  constructor(
    //public navCtrl: NavController,
    //public navParams: NavParams,
    public reportService: ReportService,
    public userService: UserService,
    public alertController: AlertController,
    public loadingCtrl: LoadingController,
    private ExportTableService: ExportTableService,
    private CalendarService: CalendarService,
    private ChartsService: ChartsService,
    private router: Router // ,
  ) // private googleAnalytics: GoogleAnalytics
  {
    this.stats = [];
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'amount', header: 'Discount Rate' },
      { field: 'usage', header: 'Times used' },
    ];

    if (this.userService.isLoggedIn()) {
      const user = this.userService.getUser();
      this.stylistID = user.getID();
      this.readOnlyStylistPicker = !(
        user.isAdministrator() || user.getCanViewReports() === 1
      );
    }

    this.barChartOptions = {
      scales: {
        x: {
          title: {
            display: true,
            text: 'Discount Name',
          },
        }
      }
    }
  }

 
  public ngOnInit() {
    // this.googleAnalytics.trackView('DiscountReportPage')
    //   .then(() => {
    //   })
    //   .catch(() => {
    //   });
    if (!this.startDate) {
      let dateFromCache: string = localStorage.getItem('datePickerStartDate');

      if (dateFromCache && Utilities.parseDate(dateFromCache)) {
        this.startDate = Utilities.parseDate(dateFromCache);
      }
    }

    if (!this.endDate) {
      let dateFromCache: string = localStorage.getItem('datePickerEndDate');

      if (dateFromCache && Utilities.parseDate(dateFromCache)) {
        this.endDate = Utilities.parseDate(dateFromCache);
      }
    }
  }

  public ngAfterViewInit() {
    if (this.stylist) {
      this.loadStats(this.stylist, this.startDate, this.endDate);
    }
  }

  public onStylistPickerInit(initResponse: {
    success: boolean;
    stylist: Stylist;
  }) {
    if (initResponse.success) {
      this.onStylistSelect(initResponse.stylist);
    } else {
      this.isLoading = false;
      this.errorOccurredWhileLoadingStylistPicker = true;
    }
  }

  public onStylistSelect(stylist: Stylist) {
    this.isLoading = false;
    if (stylist) {
      this.stylistID = stylist.getID();
      this.stylist = stylist;
      this.loadStats(stylist, this.startDate, this.endDate);
    }
  }

  public onTapToReload() {
    this.isLoading = true;
    this.errorOccurredWhileLoadingStylistPicker = false;
    this.errorOccurredWhileLoadingStats = false;
    this.stylistPickerComponent.ngOnInit();
  }

  public rangeChanged(dateRange: SMPickerRange) {
    this.startDate = dateRange.start;
    this.endDate = dateRange.end;
    this.timeManager(dateRange.start, dateRange.end);
    this.loadStats(this.stylist, this.startDate, this.endDate);
  }

  public loadStats(stylist: Stylist, startDate: Date, endDate: Date) {
    this.timeManager(startDate, endDate);
    this.isLoading = true;
    this.errorOccurredWhileLoadingStats = false;
    this.reportService
      .loadDiscountStats(stylist.id, startDate, endDate)
      .subscribe({
        next: (rows) => {
          this.stats = rows;
          this.isLoading = false;
          this.barChartData.datasets[0].data = [];
          this.barChartLabels = [];
          this.stats.forEach((stat) => {
            this.barChartData.datasets[0].data.push(stat.usage);
            this.barChartLabels.push(stat.name);
          });
          this.barChartData.labels = this.barChartLabels
          //this.content.resize();
        },
        error: (e) => {
          this.isLoading = false;
          this.errorOccurredWhileLoadingStats = true;
          //this.content.resize();
        },
      });
  }

  public timeManager(dateRangeStart, dateRangeEnd) {
    let resObj = this.CalendarService.timeManager(dateRangeStart, dateRangeEnd);
    this.xAxisDateChanger = resObj.xAxisDateChanger;
    this.yearIndicator = resObj.yearIndicator;
  }

  public exportPdf() {
    this.ExportTableService.exportPdf(this.stats, 'Discounts', this.cols);
  }

  public exportExcel() {
    this.ExportTableService.exportExcel(
      this.stats,
      'Discounts',
      this.cols.map((col) => col.header)
    );
  }

  public onBack() {
    //this.navCtrl.pop();
    this.router.navigateByUrl('/reports');
  }
}
